 const API_BASE_URL = 'https://live-vastu-backend.onrender.com/api';
 const SITE_KEY = '411998a29f2746b7737bccff0ee517bf'
 let questionsTable = null;

 function initializeDataTable() {
    if (questionsTable) {
        questionsTable.destroy();
    }
    
    questionsTable = $('#questionsTable').DataTable({
        columns: [
            {
                data: null,
                render: function (data, type, row, meta) {
                    return meta.row + 1; 
                }
            },
            { 
                data: 'plan_type',
                render: function(data) {
                    if (!data) return '';
                    return data.charAt(0).toUpperCase() + data.slice(1).replace("_", " ");
                }
            },
            { 
                data: 'createdAt',
                render: function(data, type, row) {
                    // Sorting aur Filtering ke liye original millisecond timestamp use karein
                    if (type === 'sort' || type === 'type') {
                        return new Date(data).getTime();
                    }
                    // Screen par display ke liye normal date dikhayein
                    return new Date(data).toLocaleDateString();
                }
            },
            { 
                data: null,
                render: function(data) {
                    return `<a href="/pages/user-plan-details?session_id=${data.session_id}" class="view-btn">View Details</a>`;
                }
            }
        ],
        order: [[2, 'desc']] // Ab Date column (Index 2) timestamp ke base par sahi sort hoga
    });
}
 

 if(new URLSearchParams(window.location.search).get("email"))
 {

        document.getElementById("generatePdfBtn").style.display= 'none'
       
    const email = new URLSearchParams(window.location.search).get("email");

fetch(`${API_BASE_URL}/user-submissions/user-plans/${email}`,{headers: {"x-site-key": SITE_KEY}})
  .then(res => res.json())
  .then(data => {
    if (!data.success) {
      alert("No reports found");
      return;
    }

  

     if (!questionsTable) {
                initializeDataTable();
            }
            
            // Clear and add data
            questionsTable.clear();
            questionsTable.rows.add(data.data);
            questionsTable.draw();
    

    document.getElementById("user-plan-container").style.display= 'block';
     document.getElementById("questionsTable").style.display = 'table';
  //   let html = `<table class="border">
  //   <thead>
  //   <th>No.</th>
  //   <th>Plan Type</th>
  //   <th>Date</th>
  //   <th>Actions</th>
  //   </thead>
  //  <tbody> `
  
  //   data.data.forEach((item, index) => {
  //     html += `<tr>
  //       <td> ${index + 1}</td>
  //       <td> ${item.plan_type}</td>
  //       <td> ${new Date(item.createdAt).toLocaleString()}</td>
  //       <td><a href="/pages/user-plan-details?session_id=${item.session_id}">
  //         View Report
  //       </a></td>
  //       </tr>
  //     `;
      
  //   });
  //   html += `</tbody></table>`
  //   container.innerHTML = html
  });

}else if(new URLSearchParams(window.location.search).get("session_id"))
{
  const sessionId =   new URLSearchParams(window.location.search).get("session_id")
  const container = document.getElementById("user-plan-container");
 document.getElementById("vastu-report-msg").style.display= 'none'


 fetch(`${API_BASE_URL}/user-submissions/${sessionId}`,{headers:{"x-site-key": SITE_KEY}})
  .then(res => res.json())
  .then(data => {
    if (!data.success) {
      alert("No reports found");
      return;
    }

    
    

    const container = document.getElementById("user-plan-container");

    container.style.display = "block";
    document.getElementById("questionsTable").style.display = 'none';

      const div = document.createElement("div");
      div.innerHTML = `
        <h3>Plan Details</h3>
        <p>Plan: ${data.data.plan_type.charAt(0).toUpperCase()+data.data.plan_type.slice(1).replace("_"," ")}</p>
        ${data.data.plan_type != "bronze" && `<p>Payment Status: ${data.data.payment_status}</p>`}
        <p>Date: ${new Date(data.data.createdAt).toLocaleString()}</p>
        <hr/>
      `;



      container.appendChild(div);
    // console.log(data.);

       if(data.data.ai_report)
      { 
        document.getElementById("checkReport").style.display= 'block'
             document.getElementById('checkReport').addEventListener('click',()=>{
          sessionStorage.setItem('vastu_session_id',data.data.session_id)
          sessionStorage.setItem('selected_plan',data.data.plan_type)
          sessionStorage.setItem('reportStatus','completed')
          window.location.href = '/pages/vastu-questionnaire';
        })
      }
    
      if(data.data.pdf_url)
      { 
        document.getElementById("generatePdfBtn").style.display= 'block'
        document.getElementById("vastu-report-msg").style.display= 'none'

      }
      if(data.data.report_check)
      document.getElementById('vastu-report-msg').style.display = 'none'


      if(data.data.plan_type !== 'platinum' && data.data.vastu_task){
        document.getElementById('upgradePlan').style.display = 'block'
        document.getElementById('upgradePlan').innerHTML = 'Upgrade Your Plan'
      }
       if(data.data.plan_type === 'platinum' && data.data.vastu_task === true){
        document.getElementById('upgradePlan').style.display = 'block'
        document.getElementById('upgradePlan').innerHTML = 'Renew Your Plan'
      }  

      if(data.data.plan_type !== 'bronze' && data.data.vastu_task === false){
        document.getElementById("vastu-report-msg").innerHTML = 'To generate a complete and detailed report, you will need to provide answers to a few additional questions.'
        document.getElementById('completeVastu').style.display = 'block'
        document.getElementById('completeVastu').addEventListener('click',()=>{
          sessionStorage.setItem('vastu_session_id',data.data.session_id)
          sessionStorage.setItem('selected_plan',data.data.plan_type)
          window.location.href = '/pages/vastu-premium-questions';
        })
      }

      document.getElementById('upgradePlan').addEventListener('click',function(){
        sessionStorage.setItem('vastu_session_id',data.data.session_id)
        window.location.href = '/pages/all-plan'
      })
      
    
document.getElementById("generatePdfBtn").addEventListener("click",function () {
   this.innerHTML = 'Downloading PDF...';
   
   this.disabled = true

setTimeout(() => {
        downloadPdf.call(this);
    }, 1000);

    async function downloadPdf(){
      const sessionId = data.data.session_id; 


    // const response = await fetch(`${API_BASE_URL}/pdf/download-report/${sessionId}`,{headers:{"x-site-key": SITE_KEY}});
    // let result = await response.json()
    const a = document.createElement('a');
    a.href = data.data.pdf_url;
    a.download = 'vastu-report.pdf';
    a.setAttribute('target','_blank');
    document.body.appendChild(a);
    a.click();
    this.innerHTML = 'Download PDF'
    this.disabled = false
    a.remove();

    }
    
});


})
}
